import I18n from 'I18n';
import contentOutputs from 'hubspot-prosemirror/js/prosemirror/editorCapabilities/ContentOutputTypes';
import { getMatchResults } from 'hubspot-prosemirror/prosemirror/ProsemirrorUtils';
import { BLOCKQUOTE, BOLD, CLEAR_FORMATTING, FILE_DROP, FONT_SIZE, FONT_STYLE, ITALIC, LINK, LISTS, SNIPPETS, TEXT_ALIGN, TEXT_COLOR, TEXT_HIGHLIGHT, UNDERLINE } from 'hubspot-prosemirror/prosemirror/editorCapabilities';
import { getPlaceholderPlugin } from 'hubspot-prosemirror/prosemirror/plugins/PlaceholderPlugin';
import { createSuggestionPlugin } from 'hubspot-prosemirror/prosemirror/plugins/suggestion';
import { AT_MENTION, TAG_MENTION } from 'hubspot-prosemirror/prosemirror/plugins/suggestion/suggestionsUtil';
import { fromJS } from 'immutable';
import ContentPopoverEmptyState from '../components/comments/snippets/ContentPopoverEmptyState';
import SnippetsPopoverHeader from '../components/comments/snippets/SnippetsPopoverHeader';
import { showAlert } from '../components/common/GeneralAlert';
import captureException from './captureException';
import { jsx as _jsx } from "react/jsx-runtime";
const configureMentionsPlugin = ({
  mentionOwners
}) => {
  const transformedOwners = mentionOwners.map(owner => ({
    searchText: owner.searchText,
    text: owner.text,
    id: owner.value
  }));
  return createSuggestionPlugin({
    getSuggestions: (text, done) => {
      done(getMatchResults(text, transformedOwners));
    },
    type: AT_MENTION
  });
};
const configureSnippetsPlugin = ({
  apiWrapper,
  snippetsCallback
}) => createSuggestionPlugin({
  getSuggestions: (text, done) => {
    apiWrapper.searchSnippets({
      query: text
    }).then(snippets => {
      const transformedSnippets = snippets.results.map(snippet => ({
        searchText: snippet.name,
        text: snippet.name,
        id: snippet.contentId
      }));
      done(transformedSnippets);
    }).catch(captureException);
  },
  fetchSelectSuggestion: ({
    snippet,
    handleInsert
  }) => {
    if (typeof snippetsCallback === 'function') snippetsCallback(true);
    apiWrapper.fetchUnrenderedContent({
      id: snippet.id
    }).then(data => {
      handleInsert({
        html: data.htmlBody
      });
      if (typeof snippetsCallback === 'function') snippetsCallback();
    }).catch(captureException);
  },
  type: TAG_MENTION,
  allowSpace: true
});
export const getProseMirrorRteConfig = ({
  mentionOwners,
  portalId,
  snippetsCallback,
  apiWrapper,
  openUrl
}) => {
  const baseConfig = {
    [FILE_DROP]: {
      fileDropConfig: {
        allowedFileTypes: [],
        onUnsupportedFileDropped: () => {
          showAlert({
            message: 'errors.fileDrop.message',
            title: 'errors.fileDrop.title',
            type: 'warning'
          });
        }
      }
    },
    [BOLD]: {},
    [ITALIC]: {},
    [UNDERLINE]: {},
    [CLEAR_FORMATTING]: {},
    [TEXT_ALIGN]: {},
    [LISTS]: {},
    [LINK]: {},
    [BLOCKQUOTE]: {},
    [TEXT_HIGHLIGHT]: {},
    [TEXT_COLOR]: {},
    [FONT_STYLE]: {},
    [FONT_SIZE]: {},
    [SNIPPETS]: {
      Header: () => /*#__PURE__*/_jsx(SnippetsPopoverHeader, {
        portalId: portalId,
        openUrl: openUrl
      }),
      PopoverEmptyState: () => /*#__PURE__*/_jsx(ContentPopoverEmptyState, {
        portalId: portalId,
        openUrl: openUrl
      }),
      popoverClassName: 'styled-snippets-popover',
      apiWrapper: () => ({
        fetchRenderedContent: args => apiWrapper.fetchRenderedContent(args).catch(captureException).finally(() => {
          if (typeof snippetsCallback === 'function') snippetsCallback();
        }),
        fetchUnrenderedContent: id => apiWrapper.fetchUnrenderedContent({
          id
        }).catch(captureException),
        searchSnippets: arg => apiWrapper.searchSnippets(Object.assign({}, arg)).then(response => fromJS(response)).catch(captureException)
      }),
      contactEmail: '',
      contactVid: null,
      outputType: contentOutputs.RENDERED
    }
  };
  const customPlugins = [getPlaceholderPlugin(I18n.text('comments.placeholder')), configureMentionsPlugin({
    mentionOwners
  }), configureSnippetsPlugin({
    apiWrapper,
    snippetsCallback
  })];
  return {
    baseConfig,
    customPlugins
  };
};